import React, { useEffect, useState } from "react";
import useFormComponentState from "../../../common/forms/useFormComponentState";
import { CriterionChoice } from "./CriterionChoice";
import { Toggle } from "./Toggle";
import useSelectedChoices from "./useSelectedChoices";
import { notDeletableType } from "../../../common/types/search/search";

interface CriterionChoicesProps {
	criterionKey: string;
	notDeletable?: notDeletableType;
}

export function CriterionChoices({
	criterionKey,
	notDeletable,
}: CriterionChoicesProps) {
	const { currentInput, onInputChange } = useFormComponentState(criterionKey);
	const { choices: selectedChoices } = useSelectedChoices({
		key: criterionKey,
	});
	const { choices, label } = selectedChoices.get(criterionKey).toJS();

	const choicesShown = 5;
	const choicesLength = choices.length;
	const collapseChoices = choicesLength > choicesShown;
	const [choicesCollapsed, setChoicesCollapsed] = useState(collapseChoices);

	useEffect(() => {
		setChoicesCollapsed(collapseChoices);
	}, [collapseChoices]);

	const criterionChoices = choices.map(({ key, value }, index) => {
		return (
			<CriterionChoice
				key={key}
				choiceKey={key}
				criterionKey={criterionKey}
				currentInput={currentInput}
				hidden={index >= choicesShown && choicesCollapsed}
				notDeletable={notDeletable}
				onDelete={(...args) => onInputChange(...args)}
				value={value}
			/>
		);
	});

	if (choices.length === 0) {
		return null;
	}

	return (
		<>
			<li className="criterion-name tag tag-dark-grey">{label}</li>
			{criterionChoices}
			{collapseChoices && (
				<Toggle
					choicesCollapsed={choicesCollapsed}
					choicesNumberToToggle={choicesLength - choicesShown}
					onToggle={() => setChoicesCollapsed(!choicesCollapsed)}
				/>
			)}
		</>
	);
}
